module.exports = __webpack_public_path__ + "static/media/whiteLogo.00d7609d.png";